export class ExportDashboardState {
  /**
   * @var {set}
   */
  unrenderedWidgets;

  /**
   * @var {}
   */
  readyToPaginateWidgets = {};

  /**
   *
   * @type {{}}
   */
  paginationTargetList = {};

  /**
   * @type {boolean}
   */
  isReadyToPaginate = false;

  /**
   * @type {{}}
   */
  paginationQueue = {};

  /**
   * @type {number}
   */
  measuredElementsCounter = 0;

  /**
   * @type {{}}
   */
  measuredElements = {};

  /**
   * @type {boolean}
   */
  isReadyToDisplay = false;

  /**
   * @type {{}}
   */
  paginationPerLayout = {};

  /**
   * @type {{}}
   */
  resourcesLoadingQueue = {};

  /**
   * @var {set}
   */
  mapRenderingSlots;

  constructor() {
    this.unrenderedWidgets = new Set();
    this.mapRenderingSlots = new Set();
  }
}
